module.exports = __webpack_public_path__ + "img/b040d1f.jpg";